/* Rquiere de mixin.js */

var order = {
	data() {
		return {
			dateFromOrders: '2020-07-15',
			dateToOrders: '2020-07-18',
			listOrders: [],
			subscriptionId: 0,
			methodsOrder: {
				create: 'order/register',
				createLegalDocument: '/legalDocument/register',
				createShippingRequest: '/shippingRequest/register',
				createObservation: '/observation/register',
				createPayment: '/payment/register',
				delete: '/delete',
				get: 'orders',
				show: 'order/',
				orderTrackingsOrderCreate: '/trackingsOrder/register',
			},
			paginationOrders: [],
			searchOrders: '',
			objectOrder: {
				exists: 0,
				id: 0,
				client_id: null,
				client: '',
				client_address_client_sendto_id: 0,
				total: 0,
				tithe: 0,
				status_id: null,
				status: {},
				shipping_price: 0,
				type_order_id: null,
				type_order: {},
				church_id: null,
				church: {},
				subscription_id: null,
				paid: 0,
				team_id: null,
				team: {},
				sendto: [{
					exists: 0,
					id: 0,
					client_id: null,
					address_id: null,
					street: '',
					comuna_id: null,
					client_sendto_id: null,
					sendto: '',
					phone: '',
					created_at: '',
					updated_at: ''
				}],
				order_observations: [{
					id: 0,
					order_id: 0,
					observation: '',
					created: '',
					user_id: 0,
					user: '',
					img: ''
				}],
				created_at: '',
				updated_at: '',
				order_products: [],
				order_trackings_shipping: [],
				order_payments: [],
				order_legal_documents: [],
				order_shippings_request: [],
				order_product_groups: [],
			},
			qRowsOrder: 25,
			observation: '',
			orderBy: 'orders.id',
			savingOrder: false,
			searchingOrder: false,
			tax: 0.19
		}
	},
	computed: {
		totalDiscountObjectOrderProducts() {
			let total = 0
			return total * -1
		},
		totalObjectOrderProducts() {
			let total = this.objectOrder.order_products.reduce((a, b) => {
				let c = Math.trunc(Math.abs(b.quantity)) * Math.abs(b.price)
				return a + c
			}, 0);
			return total.toFixed(0)
		},
		totalObjectOrderPayments() {
			let total = 0
			total = this.objectOrder.order_payments.reduce((a, b) => {
				let c = 0
				c = Math.abs(b.amount)
				return a + c
			}, 0);
			return total.toFixed(0)
		},
	},
	filters: {
	},
	methods: {
		addListOrders(newOrder) {
			this.listOrders.unshift(newOrder)
			if (this.listOrders.length > this.qRowsOrder) {
				this.listOrders.splice(this.qRowsOrder, 1)
			}
		},
		addListOrderObservation(newOrderObservation) {
			let index = this.listOrders.map((el) => parseInt(el.id)).indexOf(parseInt(newOrderObservation.order_id))
			if (index > -1) {
				this.listOrders[index].order_observations.push(newOrderObservation)
			}
		},
		addListOrderPayment(newOrderPayment) {
			let index = this.listOrders.map((el) => parseInt(el.id)).indexOf(parseInt(newOrderPayment.order_id))
			if (index > -1) {
				this.listOrders[index].order_payments.push(newOrderPayment)
			}
		},
		addObjectOrderProducts(newOrderProduct, position = 'down') {
			if (position == 'down') {
				this.objectOrder.order_products.push(newOrderProduct)
			} else {
				this.objectOrder.order_products.unshift(newOrderProduct)
			}
		},
		addOrderTrackingsOrder(id, trackingsOrderId, observation = '') {
			let param =
				{ 'trackingsOrderId': trackingsOrderId, 'observation': observation }
			this.$emit('showLockScreen', 'Agregando seguimiento . . .')
			let url = this.apiBackend + this.methodsOrder.show + id + this.methodsOrder.orderTrackingsOrderCreate
			this.axiosActionIS(url, 'POST', 'addOrderTrackingsOrderResult', param)
		},
		addOrderTrackingsOrderResult(response) {
			this.updateOrderStatus(response.data.data)
			this.socketEmit(['NEW_ORDER_TRACKING_ORDER'], response.data.data)
			this.addOrderTrackingsOrderResultLocal(response)
		},
		addOrderTrackingsOrderResultLocal(response) {
			console.log('addOrderTrackingsOrderResultLocal no desarrollado', response)
		},
		changeQRowsOrder() {
			localStorage.setItem('qRowsOrder', this.qRowsOrder)
			this.changeQRowsOrderLocal()
		},
		changeQRowsOrderLocal() {
			console.log('changeQRowsOrderLocal no desarrollado')
		},
		clearObjectOrder() {
			this.objectOrder.exists = 0
			this.objectOrder.client_id = null
			this.objectOrder.client = ''
			this.objectOrder.client_address_id = null
			this.objectOrder.total = 0
			this.objectOrder.tithe = 0
			this.objectOrder.status_id = null
			this.objectOrder.status = {}
			this.objectOrder.shipping_price = 0
			this.objectOrder.type_order_id = null
			this.objectOrder.type_order = {}
			this.objectOrder.church_id = null
			this.objectOrder.church = {}
			this.objectOrder.subscription_id = null
			this.objectOrder.paid = 0
			this.objectOrder.team_id = null
			this.objectOrder.team = {}
			this.objectOrder.sendto[0].exists = 0
			this.objectOrder.sendto[0].id = 0
			this.objectOrder.sendto[0].client_id = null
			this.objectOrder.sendto[0].address_id = null
			this.objectOrder.sendto[0].street = ''
			this.objectOrder.sendto[0].comuna_id = null
			this.objectOrder.sendto[0].client_sendto_id = null
			this.objectOrder.sendto[0].sendto = ''
			this.objectOrder.sendto[0].phone = ''
			this.objectOrder.sendto[0].created_at = ''
			this.objectOrder.sendto[0].updated_at = ''
			this.objectOrder.created_at = ''
			this.objectOrder.updated_at = ''
			this.objectOrder.order_observations = []
			this.objectOrder.order_products = []
			this.objectOrder.order_trackings_shipping = []
			this.objectOrder.order_payments = []
			this.objectOrder.order_legal_documents = []
			this.objectOrder.order_shipping_request = []
			this.objectOrder.order_product_groups = []
		},
		deleteItemListOrder(id) {
			let index = this.listOrders.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			let orderDeleted = this.listOrders.splice(index, 1)
			console.log(orderDeleted)
		},
		deleteItemListOrderObservation(orderObservarion) {
			let index = this.listOrders.map((el) => parseInt(el.id)).indexOf(parseInt(orderObservarion.order_id))
			if (index > -1) {
				let ind = this.listOrders[index].order_observations.map((el) => parseInt(el.id)).indexOf(parseInt(orderObservarion.id))
				if (ind > -1) {
					let orderObservacionDeleted = this.listOrders[index].order_observations.splice(ind, 1)
				}
			}
		},
		deleteItemListOrderPayment(orderPayment) {
			let index = this.listOrders.map((el) => parseInt(el.id)).indexOf(parseInt(orderPayment.order_id))
			if (index > -1) {
				let ind = this.listOrders[index].order_payments.map((el) => parseInt(el.id)).indexOf(parseInt(orderPayment.id))
				if (ind > -1) {
					let orderPaymentDeleted = this.listOrders[index].order_payments.splice(ind, 1)
				}
			}
		},
		deleteItemObjectOrderProduct(index) {
			let orderProductDeleted = this.objectOrder.order_products.splice(index, 1)
			return orderProductDeleted
		},
		deleteOrder(id) {
			this.$emit('showLockScreen', 'Borrando pedido . . .')
			this.axiosActionIS(this.apiBackend + this.methodsOrder.show + id + this.methodsOrder.delete, 'DELETE', 'deleteOrderResult')
		},
		deleteOrderObservation(order_id, id) {
			this.axiosActionIS(this.apiBackend + this.methodsOrder.show + order_id + '/observation/' + id + this.methodsOrder.delete, 'DELETE', 'deleteOrderObservationResult')
		},
		deleteOrderPayment(order_id, id) {
			this.axiosActionIS(this.apiBackend + this.methodsOrder.show + order_id + '/payment/' + id + this.methodsOrder.delete, 'DELETE', 'deleteOrderPaymentResult')
		},
		deleteOrderResult(response) {
			if (response.data.success) {
				this.$snotify.warning('Se ha borrado el pedido ' + response.data.data + ' con exito!!!', 'Borrado')
				this.deleteItemListOrder(response.data.data)
				this.socketEmit(['DELETE_ORDER'], response.data.data)
			}
			this.deleteOrderResultLocal(response)
		},
		deleteOrderResultLocal(response) {
			console.log('deleteOrderResultLocal no desarrollado', response)
		},
		deleteOrderObservationResult(response) {
			if (response.data.success) {
				this.deleteItemListOrderObservation(response.data.data);
				this.socketEmit(['DELETE_ORDER_OBSERVATION'], response.data.data)
			}
		},
		deleteOrderPaymentResult(response) {
			if (response.data.success) {
				this.deleteItemListOrderPayment(response.data.data);
				this.socketEmit(['DELETE_ORDER_PAYMENT'], response.data.data)
			}
		},
		existsTrackingOrder(order_tracking_order, tracking_order_id) {
			let index = order_tracking_order.map((el) => parseInt(el.id)).indexOf(parseInt(tracking_order_id))
			return (index > -1) ? order_tracking_order[index].created : '----/--/-- --:--'
		},
		getAllOrders(page = 1) {
			this.searchingOrder = true
			let parameters = '?search=' + this.searchOrders + '&page=' + page + '&qRow=' + this.qRowsOrder + '&fromDate=' + this.dateFromOrders + '&toDate=' + this.dateToOrders
			this.$emit('showLockScreen', 'Obteniendo lista de Pedidos . . .')
			this.axiosActionIS(this.apiBackend + this.methodsOrder.get + parameters, 'GET', 'getAllOrdersResult')
		},
		getAllOrdersDenominational(page = 1) {
			this.searchingOrder = true
			let parameters = '?'
			let url = this.apiBackend + this.methodsOrder.get + 'Denominational' + parameters
			//console.log(url)
			this.axiosActionIS(url, 'GET', 'getAllOrdersResult')
		},
		getAllOrdersByUser(page = 1) {
			this.searchingOrder = true
			let parameters = '?search=' + this.searchOrders + '&page=' + page + '&qRow=' + this.qRowsOrder + '&fromDate=' + this.dateFromOrders + '&toDate=' + this.dateToOrders
			this.$emit('showLockScreen', 'Obteniendo lista de Pedidos . . .')
			this.axiosActionIS(this.apiBackend + this.methodsOrder.get + '/getByUser' + parameters, 'GET', 'getAllOrdersResult')
		},
		getAllOrdersBySubscription(page = 1) {
			this.searchingOrder = true
			let searchOrders = this.analyzeSearch(this.searchOrders)
			let paramExtra = (searchOrders != this.searchOrders) ? this.searchOrders : ''
			let parameters = '?search=' + searchOrders + '&page=' + page + '&qRow=' + this.qRowsOrder + '&fromDate=' + this.dateFromOrders + '&toDate=' + this.dateToOrders + '&orderBy=' + this.orderBy + '&' + paramExtra
			this.$emit('showLockScreen', 'Obteniendo lista de Suscripciones . . .')
			let url = this.apiBackend + this.methodsOrder.get + '/getBySubscription/' + this.subscriptionId + parameters
			this.axiosActionIS(url, 'GET', 'getAllOrdersResult')
		},
		getAllOrdersByShippingSubscription(page = 1) {
			this.searchingOrder = true
			let parameters = '?search=' + this.searchOrders + '&page=' + page + '&qRow=' + this.qRowsOrder + '&fromDate=' + this.dateFromOrders + '&toDate=' + this.dateToOrders + '&orderBy=' + this.orderBy
			this.$emit('showLockScreen', 'Obteniendo lista de Suscripciones . . .')
			let url = this.apiBackend + this.methodsOrder.get + '/getByShippingSubscription' + parameters
			console.log(url)
			this.axiosActionIS(url, 'GET', 'getAllOrdersResult')
		},
		getAllOrdersByTeam(page = 1, teamId) {
			this.searchingOrder = true
			this.listOrders = []
			let url = this.apiBackend + 'team/' + teamId + '/orders?' + 'page=' + page
			this.axiosActionIS(url, 'GET', 'getAllOrdersResult')
		},
		getAllOrdersResult(response) {
			this.searchingOrder = false
			this.$emit('hideLockScreen')
			this.searchingOrders = false
			this.listOrders = response.data.data
			this.paginationOrders = response.data.paginate
			this.getAllOrdersResultLocal(response)
		},
		getAllOrdersResultLocal(response) {
			console.log('getAllOrdersResultLocal no desarrollado', response)
		},
		migrateOrderToGenesys(id, type) {
			let url = this.apiBackend + this.methodsOrder.show + id + '/migrateGenesys/' + type
			this.axiosActionIS(url, 'POST', 'migrateOrderToGenesysResult')
		},
		migrateOrderToGenesysResult(response) {
			if (response.data.success == true) {
				this.$snotify.info('Se migró con exito a Genesys. Nº Comp ' + response.data.data.nrocomp, 'Migración Exitosa!!!')
			}
			this.migrateOrderToGenesysResultLocal(response)
		},
		migrateOrderToGenesysResultLocal(response) {
			console.log('migrateOrderToGenesysResultLocal no desarrollado', response)
		},
		printOrderDetail(item) {
			let client = item.client.name.trim() + ' ' + item.client.surname.trim()
			let cpil = 'CPIL: ' + item.church.client.name.trim() + ' ' + item.church.client.surname.trim()
			let totalQuantity = 0
			let detail = this.repeatCharacter('#', 64) + '\n'
			detail += this.repeatCharacter(' ', 32 - parseInt(client.length / 2)) + '!!' + client + '!\n'
			detail += this.repeatCharacter(' ', 32 - parseInt(cpil.length / 2)) + cpil + '\n'
			detail += this.repeatCharacter('#', 64) + '\n'
			item.order_products.forEach(product => {
				detail += this.cleanedStringZPL(product.product.toUpperCase()) + '\n'
				detail += product.product_id
				detail += this.repeatCharacter(' ', 64 - String(product.product_id).length - String(this.methodFormatNumber(product.quantity)).length) + this.methodFormatNumber(product.quantity) + '\n'
				detail += this.repeatCharacter('-', 64) + '\n'
				totalQuantity += parseInt(product.quantity)
			})
			detail += this.repeatCharacter(' ', 47 - String(totalQuantity).length) + 'TOTAL PRODUCTOS: ' + totalQuantity + '\n'
			detail += this.repeatCharacter('#', 64) + '\n'
			console.log(detail)
			this.printFacturacionCL(window.btoa(detail), '', '', localStorage.printerFacturacionCL)
		},
		saveOrder(item) {
			this.savingOrder = true
			let method = (this.objectOrder.exists == 0) ? 'POST' : 'PUT'
			this.$emit('showLockScreen', 'Guardando datos . . .')
			if (method == 'POST') {
				this.axiosActionIS(this.apiBackend + this.methodsOrder.create, method, 'saveOrderResult', item)
			} else {
				this.axiosActionIS(this.apiBackend + this.methodsOrder.show + this.objectOrder.id, method, 'saveOrderResult', item)
			}
		},
		saveOrderAttend(id, item) {
			this.savingOrder = true
			let url = this.apiBackend + this.methodsOrder.show + id + '/storeAttendSave'
			this.axiosActionIS(url, 'POST', 'saveOrderResult', item)
		},
		saveOrderBasic(item) {
			this.savingOrder = true
			let url = this.apiBackend + this.methodsOrder.create + 'Basic'
			console.log(url, item)
			this.axiosActionIS(url, 'POST', 'saveOrderResult', item)
		},
		saveOrderLegalDocument(id, legalDocumentId) {
			this.savingOrder = true
			let param = { legalDocumentId: legalDocumentId }
			this.axiosActionIS(this.apiBackend + this.methodsOrder.show + id + this.methodsOrder.createLegalDocument, 'POST', 'saveOrderLegalDocumentResult', param)
		},
		saveOrderLegalDocumentResult(response) {
			this.savingOrder = false
			if (this.confirmResponse(response)) {
				this.saveOrderLegalDocumentResultLocal(response)
			}
		},
		saveOrderLegalDocumentResultLocal(response) {
			console.log('saveOrderLegalDocumentResultLocal no esta desarrollado', response)
		},
		saveOrderShippingRequest(id, shippingRequestId) {
			let param = { shippingRequestId: shippingRequestId }
			this.axiosActionIS(this.apiBackend + this.methodsOrder.show + id + this.methodsOrder.createShippingRequest, 'POST', 'saveOrderShippingRequestResult', param)
		},
		saveOrderShippingRequestResult(response) {
			this.savingOrder = false
			if (this.confirmResponse(response)) {
				this.$snotify.info('Se ha creado la SE Nº ' + response.data.data.shipping_request_id + ' con exito!!!', 'Nuevo')
			}
			this.saveOrderShippingRequestResultLocal(response)
		},
		saveOrderShippingRequestResultLocal(response) {
			console.log('saveOrderShippingRequestResultLocal no esta desarrollado', response)
		},
		saveOrderSubscriptionChange(id, data) {
			let url = this.apiBackend + this.methodsOrder.show + 'subscription/' + id + '/change'
			console.log(url, data)
			this.savingOrder = true
			this.axiosActionIS(url, 'POST', 'saveOrderSubscriptionChangeResult', data)
		},
		saveOrderSubscriptionChangeResult(response) {
			this.savingOrder = false
			this.saveOrderSubscriptionChangeResultLocal(response)
		},
		saveOrderSubscriptionChangeResultLocal(response) {
			console.log('saveOrderSubscriptionChangeResultLocal no desarrollado', response)
		},
		saveOrderResult(response) {
			if (!response.data.success) {
				this.$snotify.error(response.data.data, response.data.message)
			} else {
				if (response.data.message == 'NUEVO') {
					this.$snotify.success('Orden creado con el código ' + response.data.data.id, 'Nueva Orden')
					this.addListOrders(response.data.data)
					//this.setObjectOrder(response.data.data)
				} else if (response.data.message == 'ACTUALIZADO') {
					this.$snotify.info('Se ha actualizado el Pedido ' + response.data.data.id + ' con exito!!!', 'Actualizado')
					this.updateItemListOrders(response.data.data)
				}
				this.saveOrderResultLocal(response)
			}
		},
		saveOrderResultLocal(response) {
			console.log('saveOrderResultLocal no desarrollado', response)
		},
		saveOrderObservation(id) {
			let param = {
				observation: this.observation
			}
			this.axiosActionIS(this.apiBackend + this.methodsOrder.show + id + this.methodsOrder.createObservation, 'POST', 'saveOrderObservationResult', param)
		},
		saveOrderObservationResult(response) {
			if (response.data.success) {
				this.observation = ''
				this.addListOrderObservation(response.data.data)
				this.socketEmit(['NEW_ORDER_OBSERVATION'], response.data.data)
			}
		},
		saveOrderPayment(id, objectOrderPayment) {
			this.axiosActionIS(this.apiBackend + this.methodsOrder.show + id + this.methodsOrder.createPayment, 'POST', 'saveOrderPaymentResult', objectOrderPayment)
		},
		saveOrderPaymentResult(response) {
			if (this.confirmResponse(response)) {
				this.addListOrderPayment(response.data.data)
				this.socketEmit(['NEW_ORDER_PAYMENT'], response.data.data)
			}
			this.saveOrderPaymentResultLocal(response)
		},
		saveOrderPaymentResultLocal(response) {
			console.log('saveOrderPaymentResultLocal no desarrollado', response)
		},
		setListeningOrder() {
			this.sockets.subscribe('DELETE_ORDER', (data) => { this.deleteItemListOrder(data.body) })
			this.sockets.subscribe('DELETE_ORDER_OBSERVATION', (data) => { this.deleteItemListOrderObservation(data.body) })
			this.sockets.subscribe('DELETE_ORDER_PAYMENT', (data) => { this.deleteItemListOrderPayment(data.body) })
			if (this.auth.role_id != 9 && this.auth.role_id != 10)
				this.sockets.subscribe('NEW_ORDER', (data) => { this.addListOrders(data.body) })
			this.sockets.subscribe('NEW_ORDER_OBSERVATION', (data) => { this.addListOrderObservation(data.body) })
			this.sockets.subscribe('NEW_ORDER_PAYMENT', (data) => { this.addListOrderPayment(data.body) })
			this.sockets.subscribe('UPDATE_ORDER', (data) => { this.updateItemListOrders(data.body) })
			this.sockets.subscribe('NEW_ORDER_TRACKING_ORDER', (data) => { this.updateOrderStatus(data.body) })
		},
		setObjectOrder(item) {
			let newItem = Object.create(item)
			for (const property in newItem) {
				this.objectOrder[property] = newItem[property]
			}
		},
		setOrderByOrder(orderBy) {
			this.orderBy = orderBy
			this.getAllOrdersBySubscription()
		},
		setOrderInit() {
			this.qRowsOrder = (localStorage.getItem('qRowsOrder') === null) ? this.qRowsOrder : localStorage.getItem('qRowsOrder')
			this.typeStatusId = 1
			this.dateFromOrders = this.currentDate(-30)
			this.dateToOrders = this.currentDate()
			this.setOrderInitLocal()
		},
		setOrderInitLocal() { },
		showOrder(id, action = 'view') {
			let param = '?action=' + action
			this.axiosActionIS(this.apiBackend + this.methodsOrder.show + id + param, 'GET', 'showOrderResult', null)
		},
		showOrderForAttend(id) {
			let url = this.apiBackend + this.methodsOrder.show + id + '/showForAttend'
			console.log(url)
			this.axiosActionIS(url, 'GET', 'showOrderResult', null)
		},
		showOrderResult(response) {
			if (this.confirmResponse(response)) {
				this.showOrderResultLocal(response)
			}
		},
		showOrderResultLocal(response) {
			console.log('showOrderResultLocal no desarrollado', response)
		},
		storeLegalDocumentForShippingSubscription(id) {
			let data = {
			}
			let url = this.apiBackend + this.methodsOrder.show + id + '/storeLegalDocumentForShippingSubscription'
			this.axiosActionIS(url, 'POST', 'storeLegalDocumentForShippingSubscriptionResult', data)
		},
		storeLegalDocumentForShippingSubscriptionResult(response) {
			if (response.data.success == true) {

			}
			this.storeLegalDocumentForShippingSubscriptionResultLocal(response)

		},
		storeLegalDocumentForShippingSubscriptionResultLocal(response) {
			console.log('storeLegalDocumentForShippingSubscriptionResultLocal no desarrollado', response)
		},
		updateItemListOrders(item) {
			let index = this.listOrders.map((el) => parseInt(el.id)).indexOf(parseInt(item.id))
			if (index > -1) {
				console.log(item, this.listOrders[index])
				for (const property in item) {
					this.listOrders[index][property] = item[property]
				}
			}
			if (this.objectOrder.id == item.id) {
				this.setObjectOrder(item)
			}
		},
		updateOrderStatus(orderTrackingsOrder) {
			if (Object.entries(orderTrackingsOrder.statu).length > 0) {
				let index = this.listOrders.map((el) => parseInt(el.id)).indexOf(parseInt(orderTrackingsOrder.order_id))
				if (index > -1) {
					this.listOrders[index].status_id = orderTrackingsOrder.statu.id
					this.listOrders[index].status = orderTrackingsOrder.statu.name
					this.listOrders[index].color = orderTrackingsOrder.statu.color
					this.listOrders[index].order_tracking_order.push(orderTrackingsOrder)
					this.existsTrackingsOrder
				}
			}
		}
	},
};

export default order;